
export default function About() {
  return (
    <section className="w-full">
      <div className="grid grid-cols-2">
        {/* Left Side - Image */}
        <div className="relative bg-[#F5F1E8] h-[700px]">
          <div className="absolute top-8 left-8">
            <span className="text-xs uppercase tracking-wider text-[#3E2723] font-semibold">OUR STORY</span>
          </div>
          <img 
            src="https://public.readdy.ai/ai/img_res/0b11600bf480362388f58a3269daf5bd.jpg" 
            alt="Longhorn cattle with cross" 
            className="w-full h-full object-cover"
          />
          <div className="absolute bottom-12 left-12">
            <div className="text-[#3E2723]" style={{ fontFamily: 'Playfair Display, serif' }}>
              <div className="text-5xl font-normal mb-2">Faithful</div>
              <div className="text-6xl font-bold mb-2">Stewardship</div>
              <div className="text-5xl font-normal">Since 2010</div>
            </div>
          </div>
        </div>

        {/* Right Side - Content */}
        <div className="bg-white flex items-center justify-center px-16 py-20">
          <div className="max-w-xl">
            <h2 className="text-5xl font-bold text-[#3E2723] mb-8 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
              Where Faith Meets<br />The Open Range
            </h2>
            <div className="space-y-6 text-lg text-[#616161] leading-relaxed">
              <p>
                Cows4Christ began with a simple vision: to honor God through the faithful stewardship of His creation. What started as a small ranch has grown into a ministry that touches lives across our community.
              </p>
              <p>
                We believe that caring for longhorn cattle is more than a livelihood—it's a calling. Each day on the ranch is an opportunity to demonstrate Christian values of hard work, compassion, and service to others.
              </p>
              <p>
                Through our work, we support local families, provide educational opportunities for youth, and share the message of faith with everyone we meet. Our longhorns are not just livestock; they're ambassadors of God's grace and provision.
              </p>
            </div>
            <button className="mt-10 px-8 py-3.5 bg-[#3E2723] text-white rounded-full font-semibold hover:bg-[#5D4037] transition-all whitespace-nowrap">
              Learn Our Story →
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
